module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "storekeepers-freight right-panel md-elevation-1 md-scrollbar md-theme-default",
    attrs: {
      "id": "freights"
    }
  }, [_c('div', {
    staticClass: "entity-card"
  }, [_c('div', {
    staticClass: "md-layout-row entity-card-head"
  }, [_c('div', {
    staticClass: "md-layout-item entity-head-left"
  }, [(_vm.freight && _vm.freight.traking_number) ? _c('span', [_vm._v(_vm._s('№ ' + _vm.freight.traking_number))]) : _vm._e()]), _c('div', {
    staticClass: "md-layout-item entity-head-center"
  }, [(_vm.freight && _vm.freight.id) ? _c('div', {
    staticClass: "md-caption debt"
  }, [(_vm.canIssue) ? _c('div', {
    staticClass: "allow"
  }, [_vm._v("Выдача разрешена")]) : _c('div', {
    staticClass: "deny"
  }, [_vm._v("Выдача запрещена")])]) : _vm._e()]), _c('div', {
    staticClass: "md-layout-item entity-head-right"
  }, [(_vm.canChangeFreight && (_vm.canAcceptFreights || _vm.$route.params.id != 'new')) ? _c('md-button', {
    staticClass: "md-primary md-icon-button md-dense close small",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_c('md-icon', [_vm._v("check")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom",
      "md-delay": "500"
    }
  }, [_vm._v("Сохранить")])], 1) : _vm._e(), _c('md-button', {
    staticClass: "md-icon-button md-dense close small",
    attrs: {
      "to": {
        name: 'StorekeepersFreights'
      },
      "disabled": _vm.loading
    }
  }, [_c('md-icon', [_vm._v("close")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom",
      "md-delay": "500"
    }
  }, [_vm._v("Отменить")])], 1)], 1)]), _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "entity-card-body"
  }, [(_vm.freight && _vm.freight.status) ? _c('z-input', {
    attrs: {
      "name": "freight_status",
      "id": "freight_status",
      "label": "Статус груза",
      "error": _vm.errors.first('freight_status'),
      "disabled": "disabled",
      "readonly": "readonly"
    },
    model: {
      value: (_vm.freight.status.name),
      callback: function($$v) {
        _vm.$set(_vm.freight.status, "name", $$v)
      },
      expression: "freight.status.name"
    }
  }) : _vm._e(), (!_vm.form.deal_id) ? _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:999'),
      expression: "'required|min_value:1|max_value:999'"
    }],
    attrs: {
      "name": "seats_number",
      "id": "seats_number",
      "label": "Количество мест",
      "type": "number",
      "min": 1,
      "max": 999,
      "disabled": _vm.loading || _vm.$route.params.id !== 'new',
      "readonly": _vm.loading || _vm.$route.params.id !== 'new',
      "data-vv-as": " ",
      "error": _vm.errors.first('seats_number')
    },
    model: {
      value: (_vm.form.seats_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "seats_number", $$v)
      },
      expression: "form.seats_number"
    }
  }) : _vm._e(), ((_vm.$route.params.id === 'new')) ? _c('div', {
    staticClass: "md-layout delivery"
  }, [_c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true
      }),
      expression: "{'required': true}"
    }],
    attrs: {
      "label": "Способ доставки груза",
      "id": "delivery_method_to",
      "name": "delivery_method_to",
      "required": true,
      "error": _vm.errors.first('delivery_method_to'),
      "data-vv-name": "delivery_method_to",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.form.delivery_method_to),
      callback: function($$v) {
        _vm.$set(_vm.form, "delivery_method_to", $$v)
      },
      expression: "form.delivery_method_to"
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("До терминала")]), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("До адреса клиента")])])], 1), (_vm.form.delivery_method_to && parseInt(_vm.form.delivery_method_to) === 1) ? _c('div', {
    staticClass: "md-layout-item md-alignment-top-right md-size-50"
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true
      }),
      expression: "{'required': true}"
    }],
    attrs: {
      "label": "Склад",
      "id": "to_stock",
      "name": "to_stock",
      "required": true,
      "error": _vm.errors.first('to_stock'),
      "data-vv-name": "to_stock",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.form.to_stock_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "to_stock_id", $$v)
      },
      expression: "form.to_stock_id"
    }
  }, _vm._l((_vm.allStocks), function(stock) {
    return _c('option', {
      key: stock.id,
      domProps: {
        "value": stock.id
      }
    }, [_vm._v(_vm._s(stock.name))])
  }))], 1) : _vm._e(), (_vm.form.delivery_method_to && parseInt(_vm.form.delivery_method_to) === 2) ? _c('div', {
    staticClass: "md-layout-item md-alignment-top-right md-size-50"
  }, [_c('ZInputAutocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true
      }),
      expression: "{'required': true}"
    }],
    attrs: {
      "label": "Введите точный адрес",
      "display-property": "unrestricted_value",
      "property": "unrestricted_value",
      "return": "unrestricted_value",
      "showOnFocus": true,
      "callback": _vm.suggestAddress,
      "default": _vm.form.to_address.address,
      "id": "to_address",
      "name": "to_address",
      "data-vv-name": "from_address",
      "required": true,
      "data-vv-as": ' ',
      "error": _vm.errors.first('from_address')
    },
    on: {
      "select": _vm.selectAddress,
      "clear": _vm.clearAddress
    },
    model: {
      value: (_vm.form.to_address.address),
      callback: function($$v) {
        _vm.$set(_vm.form.to_address, "address", $$v)
      },
      expression: "form.to_address.address"
    }
  })], 1) : _vm._e()]) : _vm._e(), (_vm.companies && !_vm.form.executor_company_id) ? _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('executor_company_id')
    }
  }, [_c('label', [_vm._v("Исполнитель")]), _c('md-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    attrs: {
      "disabled": _vm.loading || _vm.$route.params.id !== 'new' || !_vm.canChangeFreight,
      "id": "executor_company_id",
      "name": "executor_company_id",
      "data-vv-as": " "
    },
    model: {
      value: (_vm.form.executor_company_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "executor_company_id", $$v)
      },
      expression: "form.executor_company_id"
    }
  }, _vm._l((_vm.companies), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "disabled": parseInt(item.active) == 0
      }
    }, [_vm._v(_vm._s(((parseInt(item.nds)) ? ("с НДС " + (item.nds_value) + "%") : 'без НДС') + ' (' + item.name + ')'))])
  })), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('executor_company_id')),
      expression: "errors.has('executor_company_id')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('executor_company_id')))])], 1) : _vm._e(), (_vm.stocks && _vm.stocks.length > 1) ? _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('from_stock_id')
    }
  }, [_c('label', [_vm._v("Склад отправления")]), _c('md-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    attrs: {
      "disabled": _vm.loading || _vm.$route.params.id != 'new' || !_vm.canChangeFreight,
      "id": "from_stock_id",
      "name": "from_stock_id",
      "data-vv-as": " "
    },
    model: {
      value: (_vm.form.from_stock_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "from_stock_id", $$v)
      },
      expression: "form.from_stock_id"
    }
  }, _vm._l((_vm.stocks), function(stock) {
    return _c('md-option', {
      key: stock.id,
      attrs: {
        "value": stock.id
      }
    }, [_vm._v(_vm._s(stock.name))])
  })), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('from_stock_id')),
      expression: "errors.has('from_stock_id')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('from_stock_id')))])], 1) : _vm._e(), (_vm.statuses && _vm.statuses.length > 1) ? _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('status_id')
    }
  }, [_c('label', [_vm._v("Статус заявки")]), _c('md-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    attrs: {
      "disabled": _vm.loading || _vm.$route.params.id != 'new' || !_vm.canChangeFreight,
      "id": "status_id",
      "name": "status_id",
      "data-vv-as": " "
    },
    model: {
      value: (_vm.form.status_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "status_id", $$v)
      },
      expression: "form.status_id"
    }
  }, _vm._l((_vm.statuses), function(status) {
    return _c('md-option', {
      key: status.id,
      attrs: {
        "value": status.id
      }
    }, [_vm._v(_vm._s(status.name))])
  })), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('status_id')),
      expression: "errors.has('status_id')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('status_id')))])], 1) : _vm._e(), (_vm.freightsStatuses && _vm.freightsStatuses.length > 2) ? _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('freight_status_id')
    }
  }, [_c('label', [_vm._v("Статус груза")]), _c('md-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    attrs: {
      "disabled": _vm.loading || _vm.$route.params.id != 'new' || !_vm.canChangeFreight,
      "id": "freight_status_id",
      "name": "freight_status_id",
      "data-vv-as": " "
    },
    model: {
      value: (_vm.form.freight_status_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "freight_status_id", $$v)
      },
      expression: "form.freight_status_id"
    }
  }, _vm._l((_vm.freightsStatuses), function(status) {
    return _c('md-option', {
      key: status.id,
      attrs: {
        "value": status.id
      }
    }, [_vm._v(_vm._s(status.name))])
  })), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('freight_status_id')),
      expression: "errors.has('freight_status_id')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('freight_status_id')))])], 1) : _vm._e(), _c('div', {
    staticClass: "md-layout delivery"
  }, [_c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [(!_vm.form.deal_id) ? _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:0|max:255'),
      expression: "'min:0|max:255'"
    }],
    attrs: {
      "name": "sender_comment",
      "id": "sender_comment",
      "label": "Отправитель (Наименование/ФИО/ИНН/Паспорт)",
      "data-vv-name": "sender_comment",
      "data-vv-as": ' ',
      "error": _vm.errors.first('sender_comment')
    },
    model: {
      value: (_vm.form.sender_comment),
      callback: function($$v) {
        _vm.$set(_vm.form, "sender_comment", $$v)
      },
      expression: "form.sender_comment"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [(!_vm.form.deal_id) ? _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:0|max:255'),
      expression: "'min:0|max:255'"
    }],
    attrs: {
      "name": "recipient_comment",
      "id": "recipient_comment",
      "label": "Получатель (Наименование/ФИО/ИНН/Паспорт)",
      "data-vv-name": "recipient_comment",
      "data-vv-as": ' ',
      "error": _vm.errors.first('recipient_comment')
    },
    model: {
      value: (_vm.form.recipient_comment),
      callback: function($$v) {
        _vm.$set(_vm.form, "recipient_comment", $$v)
      },
      expression: "form.recipient_comment"
    }
  }) : _vm._e()], 1)]), (!_vm.form.deal_id) ? _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('freight_description')
    }
  }, [_c('label', [_vm._v("Комментарий кладовщика")]), _c('md-textarea', {
    attrs: {
      "name": "storekeeper_comment"
    },
    model: {
      value: (_vm.form.storekeeper_comment),
      callback: function($$v) {
        _vm.$set(_vm.form, "storekeeper_comment", $$v)
      },
      expression: "form.storekeeper_comment"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('storekeeper_comment')),
      expression: "errors.has('storekeeper_comment')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('storekeeper_comment')))])], 1) : _vm._e(), (!_vm.blockDeal) ? _c('div', {
    staticClass: "button-container"
  }, [(_vm.freight && _vm.freight.deal_id && _vm.storeFreight && parseFloat(_vm.storeFreight.size) > 0 && parseFloat(_vm.storeFreight.weight) > 0 && _vm.storeFreight.status) ? _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.onCaptureBtn()
      }
    }
  }, [_vm._v("Подписать")]) : _vm._e(), ((_vm.freight && _vm.freight.id && _vm.$route.params.id != 'new' && _vm.deal && _vm.deal.recipient_id && _vm.canIssue)) ? _c('md-button', {
    staticClass: "cart-head-item md-accent",
    on: {
      "click": _vm.issue
    }
  }, [_vm._v("Выдать груз")]) : _vm._e()], 1) : _vm._e(), (_vm.blockDeal) ? _c('div', {
    staticClass: "shipment md-caption"
  }, [_c('div', {
    staticClass: "deny"
  }, [_vm._v("Груз выдан клиенту, изменение заявки заблокированно. Выдача невозможна.")])]) : _vm._e(), _c('toggle-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.freight && _vm.freight.id && _vm.$route.params.id != 'new'),
      expression: "freight && freight.id && $route.params.id != 'new'"
    }],
    staticClass: "freight-card",
    attrs: {
      "visibility": (_vm.showFreight && _vm.freight && _vm.freight.id) ? true : false,
      "heading": 'Данные груза ' + _vm.freight.traking_number
    }
  }, [_c('freight-card', {
    ref: "freightCard",
    attrs: {
      "index": _vm.freight.id,
      "hideLink": true,
      "statuses": _vm.freightsStatuses,
      "block": _vm.blockDeal || !_vm.canChangeFreight,
      "recipient_id": (_vm.freight.deal && _vm.freight.deal && _vm.freight.deal.recipient_id) ? parseInt(_vm.freight.deal.recipient_id) : 0
    },
    on: {
      "reload": _vm.init
    },
    model: {
      value: (_vm.freight),
      callback: function($$v) {
        _vm.freight = $$v
      },
      expression: "freight"
    }
  })], 1), _c('toggle-card', {
    attrs: {
      "visibility": true,
      "heading": "Услуги груза"
    }
  }, [_c('services', {
    ref: "packageservices",
    attrs: {
      "form": "storekeeper",
      "freight": _vm.freight
    }
  })], 1), (_vm.freight && _vm.freight.deal && _vm.freight.deal.id && _vm.freight.deal.recipient_id) ? _c('toggle-card', {
    staticClass: "recipient-card",
    attrs: {
      "visibility": _vm.showRecipient,
      "heading": "Данные получателя"
    }
  }, [_c('recipient', {
    ref: "recipient",
    attrs: {
      "id": parseInt(_vm.freight.deal.recipient_id),
      "deal_id": parseInt(_vm.freight.deal.id)
    }
  })], 1) : _vm._e(), (_vm.freight && _vm.freight.deal_id && _vm.freight.deal_id != 'new' && _vm.user && _vm.user.id) ? _c('toggle-card', {
    staticClass: "comments-card",
    attrs: {
      "visibility": _vm.showComments,
      "heading": "Комментарии кладовщика"
    }
  }, [_c('comments-and-logs', {
    attrs: {
      "entity_id": parseInt(_vm.freight.deal_id),
      "entity": "deals",
      "module": "deals",
      "only_comments": true,
      "user_id": _vm.user.id,
      "placeholder": "Добавить новый комментарий"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [_c('md-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.freight.from_stock_signature),
      expression: "freight.from_stock_signature"
    }],
    class: {
      'md-invalid': _vm.errors.has('from_stock_signature'),
      'md-has-value': !!_vm.freight.from_stock_signature
    }
  }, [_c('label', [_vm._v("Подпись отправителя на складе")]), _c('wacom-signature', {
    ref: "signature",
    on: {
      "capture-complete": _vm.onCapture,
      "capture-cancel": _vm.onCaptureCancel
    },
    model: {
      value: (_vm.freight.from_stock_signature),
      callback: function($$v) {
        _vm.$set(_vm.freight, "from_stock_signature", $$v)
      },
      expression: "freight.from_stock_signature"
    }
  })], 1)], 1), _c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [(_vm.freight && _vm.freight.id) ? _c('md-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.freight.to_signature),
      expression: "freight.to_signature"
    }],
    class: {
      'md-invalid': _vm.errors.has('to_signature'),
      'md-has-value': !!_vm.freight.to_signature
    }
  }, [_c('label', [_vm._v("Подпись получателя")]), _c('wacom-signature', {
    ref: "toSignature",
    on: {
      "capture-complete": _vm.onCaptureTo,
      "capture-cancel": _vm.onCaptureCancelTo
    },
    model: {
      value: (_vm.freight.to_signature),
      callback: function($$v) {
        _vm.$set(_vm.freight, "to_signature", $$v)
      },
      expression: "freight.to_signature"
    }
  })], 1) : _vm._e()], 1)])], 1), _c('div', {
    staticClass: "entity-card-footer"
  }, [_c('ticket-print', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading && _vm.freight && _vm.freight.id),
      expression: "!isLoading && freight && freight.id"
    }],
    ref: "TicketsPrint",
    attrs: {
      "data-callback": _vm.getPrintTicketData,
      "printers": _vm.printers,
      "trackingNumber": _vm.ticketsPrintData.trackingNumber,
      "date": _vm.ticketsPrintData.date,
      "fromCity": _vm.ticketsPrintData.fromCity,
      "toCity": _vm.ticketsPrintData.toCity,
      "fromAddress": _vm.ticketsPrintData.fromAddress,
      "toAddress": _vm.ticketsPrintData.toAddress,
      "recipient": _vm.ticketsPrintData.recipient,
      "sender": _vm.ticketsPrintData.sender,
      "seatsNumber": parseInt(_vm.ticketsPrintData.seatsNumber),
      "temperature-regime": _vm.ticketsPrintData.tempReg
    }
  }), (_vm.freight && _vm.freight.deal_id) ? _c('div', {
    staticClass: "print-btn",
    on: {
      "click": function($event) {
        _vm.printDoc(_vm.freight.deal_id, 'stock_note')
      }
    }
  }, [_vm._v("Складская записка")]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d76b430","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/storekeepers_stocks/views/Freight.vue
// module id = 1179
// module chunks = 0